module.exports = __webpack_public_path__ + "img/future.d3dd1bd9.jpg";